module.exports = __webpack_public_path__ + "img/5.1614d366.jpg";